import { ReactComponent as TattooMachineIcon } from '../assets/images/tattoo-machine.svg';
import { ReactComponent as DiversityIcon } from '../assets/images/diversity.svg';
import { ReactComponent as SafetyIcon } from '../assets/images/safety.svg';
import '../assets/styles/shopValues.css';
import useWindowDimensions from '../hooks/windowDimensions';

export default function ShopValues() {

    const { width } = useWindowDimensions();


    let value = width <= 600 ? "100px" : (width >= 1024 ? "90px" : "70px");

    return (
        <div className="shop-values">
            <div className="shop-values-container">
                <ul className='shop-values-list'>
                    <li className='shop-values-item'>
                        <TattooMachineIcon className='shop-value-logo' style={{ maxWidth: value, maxHeight: value }} />
                        <h3>Artistic Mastery</h3>
                    </li>
                    <li className='shop-values-item'>
                        <SafetyIcon className='shop-value-logo' style={{ maxWidth: value, maxHeight: value }} />
                        <h3>Sanctuary of Safety</h3>
                    </li>
                    <li className='shop-values-item'>
                        <DiversityIcon className='shop-value-logo' style={{ maxWidth: value, maxHeight: value }} />
                        <h3>Creative Diversity</h3>
                    </li>
                </ul>
            </div>
        </div>
    )
}


